import React from 'react'
import { bool, string } from 'prop-types'

import getNewIcon from 'utils/getNewIcon'
import { SVGIcon } from 'components/qstrap'

const SearchResultsCategory = ({ icon, title, isNewSearch }) => (
  <div className="search__results-category">
    <div className="search__results-category-icon">
      {isNewSearch ? getNewIcon(icon) : <SVGIcon name={icon} />}
    </div>
    <span className="search__results-category-text">{ title }</span>
    <style jsx>
      {`
        .search__results-category {
          margin: 24px 16px 8px;
          display: flex;
          &-icon {
            margin-right: 8px;
            width: 20px;
            height: 20px;
            :global(svg) {
              width: 20px;
              height: 20px;
            }
          }
          &-text {
            font-size: 16px;
            font-weight: 700;
          }
        }
      `}
    </style>
  </div>
)

SearchResultsCategory.propTypes = {
  icon: string,
  title: string,
  isNewSearch: bool,
}

SearchResultsCategory.defaultProps = {
  isNewSearch: false,
}

export default SearchResultsCategory
